// ControlledAskBox.jsx
import React, { useState, forwardRef } from "react";
import { AskBox } from "../AskBox";

export const ControlledAskBox = forwardRef(({
  disabled = false,
  onAsked,
  ...rest
}, ref) => {
  const [instanceKey, setInstanceKey] = useState(0);

  const handleAsked = (q) => {
    onAsked?.(q);
    setInstanceKey((k) => k + 1);
  };

  return (
    <div style={{ position: "relative", opacity: disabled ? 0.6 : 1 }}>
      <AskBox 
        key={instanceKey} 
        ref={ref} 
        onAsked={handleAsked} 
        {...rest} 
      />
      {disabled && (
        <div
          aria-hidden
          style={{
            position: "absolute",
            inset: 0,
            cursor: "not-allowed",
            pointerEvents: "auto",
          }}
        />
      )}
    </div>
  );
});

ControlledAskBox.displayName = 'ControlledAskBox';